import { createContext } from 'react';

export const DesenlacesContext =  createContext ();